import { INodeList, ISimplifiedNode } from './IngestedTree'
import { NodeType } from 'shared/types/ingestion'

export function isNodeList(node: ISimplifiedNode): node is INodeList {
  return node.type === NodeType.NodeList
}

export function isNodeListOfType(
  node: ISimplifiedNode,
  listType: NodeType,
): node is INodeList {
  return isNodeList(node) && node.nodes[0]?.type === listType
}
